'use strict';

var React = require('react');

var SvgSimplifyMinor = function SvgSimplifyMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.294 4.293-3 3a.997.997 0 0 0 0 1.414l3 3a1 1 0 1 0 1.414-1.414l-1.293-1.293h3.586a1 1 0 0 0 0-2h-3.586l1.293-1.293a1 1 0 0 0-1.414-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.708 8.293a1 1 0 1 0-1.415 1.414l1.293 1.293h-3.586a1 1 0 1 0 0 2h3.586l-1.293 1.293a1.002 1.002 0 0 0 0 1.414.998.998 0 0 0 1.415 0l3-3a.996.996 0 0 0 0-1.414l-3-3Z"
  }));
};

exports.SvgSimplifyMinor = SvgSimplifyMinor;
